// src/services/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// ─── Replace with your Firebase project credentials ───────────────────────────
const firebaseConfig = {
  apiKey: "AIzaSyDfW62pjwoh-SSqEBEPEsmFXAcqNd5LNFk",
  authDomain: "tripuraagrouser.firebaseapp.com",
  projectId: "tripuraagrouser",
  storageBucket: "tripuraagrouser.firebasestorage.app",
  messagingSenderId: "679850089724",
  appId: "1:679850089724:web:a54bc738886a8d0721cb79",
  measurementId: "G-NGKWZ0TKE6"
};
// ──────────────────────────────────────────────────────────────────────────────

const app  = initializeApp(firebaseConfig);
export const db      = getFirestore(app);
export const auth    = getAuth(app);
export const storage = getStorage(app);
export default app;
